import { createStore, applyMiddleware, compose } from "redux"
import {
  routerMiddleware,
  push,
  replace,
  LOCATION_CHANGE
} from "react-router-redux"
import thunkMiddleware from "redux-thunk"
import createHistory from "history/createBrowserHistory"
// TODO move reducer into store
import rootReducer from "../rootReducer.js"
import {
  getUser,
  login,
  auth,
  unAuth,
  checkAuthedOrPush
} from "../user/actions"
import Raven from "raven-js"
import createRavenMiddleware from "raven-for-redux"
import * as mapActionCreators from "../map/actions"
import * as tripActionCreators from "../trips/actions"
Raven.config(
  "https://d9288dafe9604818b4d5cf0a30485fdd@sentry.io/280335"
).install()
const queryString = require("query-string")
// Create a history of your choosing (we're using a browser history in this case)
export const history = createHistory()

const removeHash = store => next => action => {
  // let result = next(action)
  const { getState, dispatch } = store

  if (action.type == LOCATION_CHANGE) {
    const location = action.payload
    const { pathname, search, hash } = action.payload

    // TODO mutate or create newAction instead
    if (hash.indexOf("/") == 1) return dispatch(replace(hash.slice(1)))
    // if (hash.indexOf("/")==1) {
    //   action.payload.pathname=hash.slice(1)
    // }
  }
  return next(action) //result
}

const queryHandler = location => {
  // // set state for: slt, plan, signup_type, coupon, plan
  const { search } = location
  const newLocation = { ...location }

  if (search) {
    const parsed = queryString.parse(search)
    // newLocation.params = parsed

    // once params are set in state, remove them all
    // newLocation.search = null
    // set state for: slt, plan, signup_type, coupon, plan
    if (parsed.slt) {
      delete parsed.slt
    }
    if (parsed.removeme) {
      delete parsed.removeme
    }

    newLocation.search = Object.keys(parsed).length
      ? "?" + queryString.stringify(parsed)
      : ""

    if (parsed.plan) newLocation.pathname = "premium"
    if (parsed.redirect_to) newLocation.pathname = parsed.redirect_to
    if (parsed.signup_type) newLocation.pathname = parsed.signup_type
  }

  return newLocation
}
// ROUTER ACTION CREATORS
export const routerActionCreators = {
  handleEmailParam: () => ({
    type: "HANDLE_EMAIL_PARAM",
    wfemail: "foo@email.com"
  }), //NOTE this should be "@@router/LOCATION_CHANGE"
  locationRemoveParam: payload => ({
    type: "@@router/LOCATION_REMOVE_PARAM",
    payload
  }),
  locationSet: payload => ({ type: "@@router/LOCATION_SET", payload }),
  push: () => {
    return (dispatch, getState) => {
      dispatch(
        push({
          ...getState().router.location
        })
      )
    }
  },
  renderLocation: () => {
    return (dispatch, getState) => {
      dispatch(
        push({
          ...getState().router.location
        })
      )
    }
  },
  replace: () => {
    return (dispatch, getState) => {
      dispatch(
        push({
          ...getState().router.location
        })
      )
    }
  },
  pushWithState: () => {
    return (dispatch, getState) => {
      dispatch(
        push({
          ...getState().router.location,
          pathname: "/premium"
          // search:'?slt=123&email=test@test.com'
        })
      )
    }
  },
  handleParams: () => {
    return (dispatch, getState) => {
      const { location } = getState().router
      const { pathname, search, hash } = location
      const { token_id, isAuthenticated } = getState().models.user
      const { hasOnboarded } = getState().user

      if (search) {
        const {
          rm_before_auth,
          rm_after_auth,
          plan,
          redirect_to,
          signup_type,
          coupon
        } = queryString.parse(search)

        // set state for: slt, plan, signup_type, coupon, plan
        if (rm_before_auth)
          dispatch({
            type: "@@router/LOCATION_REMOVE_PARAM",
            payload: "rm_before_auth"
          })

        if (plan)
          dispatch({
            type: "@@router/LOCATION_SET",
            payload: { pathname: "premium" }
          })

        // wait till we have the user authenticated...
        if (isAuthenticated && token_id) {
          if (rm_after_auth)
            dispatch({
              type: "@@router/LOCATION_REMOVE_PARAM",
              payload: "rm_after_auth"
            })
          if (signup_type) {
            dispatch({
              type: "@@router/LOCATION_SET",
              payload: { pathname: signup_type }
            })
            dispatch({
              type: "@@router/LOCATION_REMOVE_PARAM",
              payload: "signup_type"
            })
          }
        }

        if (redirect_to && hasOnboarded) {
          dispatch({
            type: "@@router/LOCATION_SET",
            payload: { pathname: redirect_to }
          })
          dispatch({
            type: "@@router/LOCATION_REMOVE_PARAM",
            payload: "redirect_to"
          })
        }
      }
    }
  },
  tryTimeout: () => ({ type: "TRY_TIMEOUT", meta: { delay: 2000 } })
}

const crashReporter = store => next => action => {
  try {
    return next(action) // dispatch
  } catch (err) {
    console.error("Caught an exception in middleware!", err)
    window["_fs_ready"] = function() {
      var fsSessionUrlAtTime = window.FS.getCurrentSessionURL(true)
      // The above URL will take you to the current time within the session

      Raven.setExtraContext({
        fsUrl: fsSessionUrlAtTime,
        hasFsUrl: true
      })
      Raven.setTagsContext({
        hasFS: true
      })
    }
    // Raven.captureException(err, { // send to crash reporting tool
    //   extra: {
    //     action,
    //     state: store.getState(), // dump application state
    //     // fsUrl: fsSessionUrlAtTime,
    //     test:'fake'
    //   }
    // });

    throw err // re-throw error
  }
}

// // https://github.com/zalmoxisus/redux-devtools-extension/commit/477e69d8649dfcdc9bf84dd45605dab7d9775c03
export function showRfActions() {
  return { type: "SHOW_RF_ACTIONS" }
}
export function mockPremium() {
  return { type: "MOCK_PREMIUM" }
}
export function mockEnterprise() {
  return { type: "MOCK_ENTERPRISE" }
}
export function mockAccountant() {
  return { type: "MOCK_ACCOUNTANT" }
}
export function mockAccountantWithClients() {
  return { type: "MOCK_ACCOUNTANT_WITH_CLIENTS" }
}
export function mockCobrandMember() {
  return {
    type: "MOCK_USER",
    user: {
      group_as_enterprise_owner: null,
      group_as_enterprise_member: null,
      group_as_cobrand_member: {
        token_id: "9a50dd8d0bc94f14bda89f2eb3a12676",
        company_name: "Dasher",
        description: null,
        photo: {
          token_id: "589eae34bb624ee0892f10ebee8de57d",
          image_url:
            "https://everlance.s3.amazonaws.com/uploads/photo/2018-01-26-589eae34bb624ee0892f10ebee8de57d/DoorDash_logo_wordmark_copy.png"
        },
        stripe_coupon: {
          id: "dasher1",
          amount_off: 5900,
          percent_off: 10,
          valid: true,
          duration: "once",
          duration_in_months: null
        }
      }
    }
  }
}

// export function mockEnterpriseWithDiscount() {
//   return {type: 'MOCK_USER', user: {
//     "group_as_enterprise_owner":{
//       price_per_active: 1000,
//       stripe_coupon: {
//           "id": "dasher1",
//           "amount_off": 5900,
//           "percent_off": 10,
//           "valid": true,
//           "duration": "once",
//           "duration_in_months": null
//       }
//     },
//     "group_as_enterprise_member":null,
//     "group_as_cobrand_member": null
//   }}
// }

export function mockTeamOwner() {
  return {
    type: "MOCK_USER",
    user: {
      group_as_enterprise_member: null,
      group_as_enterprise_owner: {
        price_per_active: 2500
      },
      group_as_cobrand_member: null
    }
  }
}

export function mockTeamOwnerDiscount() {
  return {
    type: "MOCK_USER",
    user: {
      group_as_enterprise_member: null,
      group_as_enterprise_owner: {
        price_per_active: 1100,
        stripe_coupon: {
          // "amount_off": 5900,
          percent_off: 56
        }
      },
      group_as_cobrand_member: null
    }
  }
}

export function mockNoGroup() {
  return {
    type: "MOCK_USER",
    user: {
      group_as_accountant: null,
      group_as_enterprise_owner: null,
      group_as_enterprise_member: null,
      group_as_cobrand_member: null
    }
  }
}

export function mockSubscription() {
  return (dispatch, getState) =>
    dispatch({
      type: "MOCK_USER",
      user: {
        subscription: getState().models.user.subscription
          ? null
          : {
              token_id: "366352c2c2f148c19e827567128f6e0f",
              product_identifier: "stripe.monthly.premium.group.25",
              type: "StripeSubscription",
              customer: {
                subscription: {
                  quantity: 1
                },
                source: {
                  last4: "4242",
                  exp_month: 4,
                  exp_year: 2024,
                  brand: "Visa"
                },
                account_balance: "$0.00",
                trial_days_remaining: 0,
                current_period_end: "Friday, May 11, 2018",
                cancel_at_period_end: false
              }
            }
      }
    })
}
const actionCreators = {
  removeEnforcedValueOption: () => {
    return {
      type: "REMOVE_ENFORCED_VALUE_OPTION"
    }
  },
  mockPremium,
  mockEnterprise,
  mockAccountant,
  mockAccountantWithClients,
  mockCobrandMember,
  mockNoGroup,
  mockSubscription,
  // for data export recipients field:
  mockUserBelongsToGroup: () => ({
    type: "MOCK_USER",
    user: {
      group_as_client: {},
      group_as_enterprise_member: {}
    }
  }),
  mockTeamOwner,
  mockTeamOwnerDiscount,
  showRfActions,
  // ...mapActionCreators, ...tripActionCreators,
  ...routerActionCreators
}

// const actionSanitizer = (action) => (
//   action.type === 'USER_SUCCESS' && action.user ?
//   { ...action, user: '<<LONG_BLOB>>' } : action
// );
const actionTransformer = action =>
  action.type === "RECEIVE_DIRECTIONS" && action.response
    ? { ...action, response: "<<LONG_BLOB>>" }
    : action
// https://github.com/zalmoxisus/remote-redux-devtools
const stateTransformer = state =>
  state.form &&
  (state.form.changePassword || state.form.login || state.form.signup)
    ? { ...state, form: { password: "<<HIDDEN>>" } }
    : state

const options = {
  actionsBlacklist: [
    // '@@redux-form/'
  ],
  actionCreators,
  // actionsBlacklist: 'SOME_ACTION'
  // or actionsBlacklist: ['SOME_ACTION', 'SOME_OTHER_ACTION']
  // or just actionsBlacklist: 'SOME_' to omit both
  actionSanitizer: actionTransformer,
  // stateSanitizer: (state) => state.models ? { ...state, models: '<<LONG_BLOB>> (see configureStore.js)' } : state,
  stateSanitizer: stateTransformer,
  shouldCatchErrors: true,
  // predicate: (state, action) => state.dev.logLevel === 'VERBOSE' && !action.forwarded
  predicate: (state, action) =>
    !/^@@redux-form/.test(action.type) || state.dev.logLevel === "VERBOSE"
}

export default function configureStore(initialState) {
  const composeEnhancers =
    (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(options)) ||
    compose
  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(
      applyMiddleware(
        crashReporter,
        rafScheduler,
        timeoutScheduler,
        // thunk,
        // vanillaPromise,
        // readyStatePromise,
        // authInterceptor,
        removeHash,
        // Build the middleware for intercepting and dispatching navigation actions
        routerMiddleware(history),
        thunkMiddleware,
        createRavenMiddleware(Raven, {
          stateTransformer,
          actionTransformer
        })
      )
    )
  )

  return store
}

/**
 * Schedules actions with { meta: { delay: N } } to be delayed by N milliseconds.
 * Makes `dispatch` return a function to cancel the timeout in this case.
 */
const timeoutScheduler = store => next => action => {
  if (!action.meta || !action.meta.delay) {
    return next(action)
  }
  let timeoutId = setTimeout(() => next(action), action.meta.delay)
  return function cancel() {
    clearTimeout(timeoutId)
  }
}
/**
 * Schedules actions with { meta: { raf: true } } to be dispatched inside a rAF loop
 * frame.  Makes `dispatch` return a function to remove the action from the queue in
 * this case.
 */
const rafScheduler = store => next => {
  let queuedActions = []
  let frame = null
  function loop() {
    frame = null
    try {
      if (queuedActions.length) {
        next(queuedActions.shift())
      }
    } finally {
      maybeRaf()
    }
  }
  function maybeRaf() {
    if (queuedActions.length && !frame) {
      frame = requestAnimationFrame(loop)
    }
  }
  return action => {
    if (!action.meta || !action.meta.raf) {
      return next(action)
    }
    queuedActions.push(action)
    maybeRaf()
    return function cancel() {
      queuedActions = queuedActions.filter(a => a !== action)
    }
  }
}
/**
 * Lets you dispatch promises in addition to actions.
 * If the promise is resolved, its result will be dispatched as an action.
 * The promise is returned from `dispatch` so the caller may handle rejection.
 */
const vanillaPromise = store => next => action => {
  if (typeof action.then !== "function") {
    return next(action)
  }
  return Promise.resolve(action).then(store.dispatch)
}
/**
 * Lets you dispatch special actions with a { promise } field.
 *
 * This middleware will turn them into a single action at the beginning,
 * and a single success (or failure) action when the `promise` resolves.
 *
 * For convenience, `dispatch` will return the promise so the caller can wait.
 */
const readyStatePromise = store => next => action => {
  if (!action.promise) {
    return next(action)
  }
  function makeAction(ready, data) {
    let newAction = Object.assign({}, action, { ready }, data)
    delete newAction.promise
    return newAction
  }
  next(makeAction(false))
  return action.promise.then(
    result => next(makeAction(true, { result })),
    error => next(makeAction(true, { error }))
  )
}
/**
 * Lets you dispatch a function instead of an action.
 * This function will receive `dispatch` and `getState` as arguments.
 *
 * Useful for early exits (conditions over `getState()`), as well
 * as for async control flow (it can `dispatch()` something else).
 *
 * `dispatch` will return the return value of the dispatched function.
 */
const thunk = store => next => action =>
  typeof action === "function"
    ? action(store.dispatch, store.getState)
    : next(action)



// WEBPACK FOOTER //
// ./src/store/configureStore.js